import { ReactNode, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import FullPageLoader from './FullPageLoader';

interface RequireAuthProps {
  children: ReactNode;
  fallback?: ReactNode;
}

export default function RequireAuth({ children, fallback }: RequireAuthProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, loading } = useAuth();

  // ✅ Hook'lar koşulsuz - her zaman çalışıyor
  useEffect(() => {
    if (!loading && !user) {
      // Kullanıcı giriş yapmamış - login'e yönlendir
      const returnTo = location.pathname + location.search;
      navigate(`/auth?redirect=${encodeURIComponent(returnTo)}`, { replace: true });
    }
  }, [user, loading, navigate, location]);

  // ✅ Loading durumu
  if (loading) {
    return <FullPageLoader />;
  }

  // ✅ Kullanıcı yoksa fallback göster (veya null)
  if (!user) {
    return fallback ? <>{fallback}</> : null;
  }

  // ✅ Kullanıcı varsa children'ı render et
  return <>{children}</>;
}
